(function ($) {
	const $window = $(window);
	var $lang = $(".lang-switcher .current-lang");

	$lang.on("click", function (e) {
		e.stopPropagation();
		$(this).parent().toggleClass("opened");
	});

	$(document).on("click", function (e) {
		const $langContainer = $(".lang-switcher");
		const $target = $(e.target);
		
		if (!$langContainer.is($target) && !$langContainer.has($target).length) {
			$langContainer.removeClass("opened");
		}
	});

	sliderBenefits();

	function sliderBenefits() {
		const $list = $(".section-benefits .list-slider"),
			$wrapper = $list.find(".list-wrapper"),
			$items = $list.find(".list-item"),
			breakpoint = 992;

		let checkInit = false;
		let $slider;

		if (!$list.length) {
			return false;
		}

		checkSliderBenefits();

		$window.resize(function () {
			checkSliderBenefits();
		});

		function checkSliderBenefits() {
			if ($window.outerWidth() <= breakpoint) {
				initSliderBenefits();
			} else {
				destroySliderBenefits();
			}
		}

		function initSliderBenefits() {
			if (checkInit) {
				return false;
			} else {
				$list.addClass("swiper");
				$items.addClass("swiper-slide");
				$wrapper.addClass("swiper-wrapper");

				setTimeout(() => {
					$slider = new Swiper($list[0], {
						wrapperClass: "list-wrapper",
						slideClass: "list-item",
						slidesPerView: 1.2,
						spaceBetween: 16,
						loop: true,
						simulateTouch: true,
						grabCursor: true,
						breakpoints: {
							768: {
								slidesPerView: 2.3,
							},
						},
					});

					checkInit = true;
				}, 10);
			}
		}

		function destroySliderBenefits() {
			if (checkInit) {
				$slider.destroy();
				checkInit = false;
				$list.removeClass("swiper");
				$items.removeClass("swiper-slide");
				$wrapper.removeClass("swiper-wrapper");
			}
		}
	}

	// // lang
	// (function () {
	// 	const path = window.location.pathname;

	// 	const supported = ["es", "pt"];

	// 	if (supported.some(l => path.startsWith("/" + l + "/"))) {
	// 		return;
	// 	}

	// 	function redirectToLanguage(lang) {
	// 		const cleanPath = path.startsWith('/') ? path.substring(1) : path;
	// 		window.location.replace(`/${lang}/${cleanPath}`);
	// 	}

	// 	const saved = localStorage.getItem("locale");

	// 	if (saved && supported.includes(saved)) {
	// 		redirectToLanguage(saved);
	// 		return;
	// 	}

	// 	const browserLang = navigator.language.toLowerCase().split("-")[0];

	// 	if (supported.includes(browserLang)) {
	// 		redirectToLanguage(browserLang);
	// 		return;
	// 	}

	// })();

	// document.addEventListener("DOMContentLoaded", () => {
	// 	document.querySelectorAll("[data-lang]").forEach(link => {
	// 		link.addEventListener("click", () => {
	// 			const lang = link.getAttribute("data-lang");
	// 			localStorage.setItem("locale", lang);
	// 		});
	// 	});
	// });

})(jQuery);
